import request from 'api/request';

export default function fetchShifts(id) {
  return request({ url: `/courses/${id}/statistics/shifts` });
}
